import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import RelayEnvironment from '../../RelayEnvironment';

const mutation = graphql`
	mutation backfillClientContactsMutation($input: BackfillClientContactsInput!) {
		backfillClientContacts(input: $input) {
			companiesProcessed
			companiesFailed
			contactsCreated
			companiesWithContactsToCreate
			dryRun
			lastCompanyId
			companiesRemaining
			companies {
				companyId
				companyName
				tier
				contactsToCreate
				contactsSkipped
				contacts {
					personId
					clientId
					clientName
					firstName
					lastName
					email
					personCreatedAt
					reason
					willCreate
				}
			}
			failures {
				companyId
				companyName
				tier
				error
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation(RelayEnvironment.getInstanceMC(), {
		mutation,
		variables,
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
